import BathLinerShowerEnclosure from "./bath-liner-shower-enclosure.svg";
import BathOther from "./bath-other.svg";
import BathShowerConversion from "./bath-shower-conversion.svg";
import FullBathRemodel from "./full-bath-remodel.svg";
import ShowerTubConversion from "./shower-to-tub-conversion.svg";
import ShowerTubReplacement from "./shower-tub-replacement.svg";
import ShowerTubUpdate from "./shower-tub-update.svg";
import WalkInShower from "./walk-in-shower.svg";
import WalkingTubAndShower from "./walking-tub-and-shower.svg";

const icons = {
  "bath-liner-shower-enclosure": BathLinerShowerEnclosure,
  "bath-other": BathOther,
  "bath-shower-conversion": BathShowerConversion,
  "full-bath-remodel": FullBathRemodel,
  "shower-to-tub-conversion": ShowerTubConversion,
  "shower-tub-replacement": ShowerTubReplacement,
  "shower-tub-update": ShowerTubUpdate,
  "walk-in-shower": WalkInShower,
  "walking-tub-and-shower": WalkingTubAndShower,
};

export default icons;
